const member = {
  // 本人借据的保障详情，身份沿既有请求封装传递。
  apiGuaranteeDetail: ['/lt-web/xs/member/guarantee/detail'],
  // 信用报告独立购买与“我的-信用报告”联登
  getCreditReportPurchaseInfo: ['/lt-web/member/creditReport/purchaseInfo'],
  sendCreditReportSms: ['/lt-web/member/creditReport/sendSms'],
  submitCreditReportPurchase: ['/lt-web/member/creditReport/purchase'],
  loginLatestCreditReport: ['/lt-web/member/creditReport/login'],
  // 花鸭权益主动支付模块
  getBenefitMemberInfo: ['/lt-web/xs/app/query/benefit/member/info'], // 根据memberorderNO获取会员相关信息
  getBenefitGetBankCardInfo: ['/lt-web/xs/app/benefit/getBankCardInfo'], // 获取银行卡相关信息
  submitBenefitPay: ['/lt-web/xs/app/benefit/pay'], // 权益主动支付
  getBenefitSendMsg: ['/lt-web/xs/app/benefit/send/msg'], // 权益绑卡验证码
  submitBenefitConfirmVerifyCode: ['/lt-web/xs/app/benefit/confirmVerifyCode'], // 校验权益绑卡验证码
  // 我的权益包
  apiUserCouponList: ['/lt-web/xs/member/userCouponList'], // 权益包列表
  apiUsedCoupon: ['/lt-web/xs/member/usedCoupon'], // 权益包立即使用
  apiGetTianchuangUrl: ['/lt-web/xs/userAuth/suppl/tianChuangJoinLoginUrlWithMerchantOrder'], // 获取天创券地址
  apiQueryBenefitInfo: ['/lt-web/xs/app/query/benefit/info'], // 查看权益详情
  // 自动续费管理
  getAutoPayList: ['/lt-web/xs/member/autoSignData'], // 获取自动续费列表
  offAutoPay: ['/lt-web/xs/member/unSignAuto'], // 关闭自动续费
  // 我的订单
  apiRefundAmount: ['/lt-web/xs/member/userdAccount'], // 实时查询权益退款可退金额
  apiPreRefund: ['/lt-web/xs/member/preRefund'], // 退款判断
  apiDoRefund: ['/lt-web/xs/member/doRefund'], // 退款提交
  apiRefundQuestionnaire: ['/lt-web/xs/member/submit/refundQuestionnaire'], // 退款问卷

  // 订单列表
  getOrderList: ['/lt-web/xs/member/orderList'], // 获取订单列表
  getAdvOrderList: ['/lt-web/xs/adv/benefit/orderList'], // 获取权益模式的订单列表
  getAdvOrderDetailUrl: ['/lt-web/xs/adv/benefit/getBenefitUrl'] // 获取行权页面
}

export default member
